<template>
  <div
    :class="`formulate-input-element formulate-input-element--${context.type}`"
    :data-type="context.type"
  >
	<div class="input-password">
		
		<div class="input-float-button" @click="showPassword=!showPassword">
			<i class="" :class="this.showPassword ? 'icon-eye-off' : 'icon-eye'"></i>
		</div>
		<input
			v-model="formatted"
			v-bind="context.attributes"
			autocomplete="no"
			@blur="context.blurHandler"
			:type="this.showPassword ? 'text' : 'password'"
		>
		<div v-if="context.attributes.showMeter">
			<password 
				v-model="formatted"
				@score="passwordScore"
				:strength-meter-only="true"
				:secureLength="6"
			/>
			<div class="password-feedback text-danger" v-if="formatted.length>0 && passwordStrength==0"> Contraseña demasiado debil</div>
			<div class="password-feedback text-warning" v-if="passwordStrength==1 || passwordStrength==2"> Recuerda utilizar combinaciones de mayúsculas, minúsculas y números.</div>
			<div class="password-feedback text-success" v-if="passwordStrength==3"> Hasta aquí bien, pero un poco más de seguridad nunca viene mal.</div>
			<div class="password-feedback text-success" v-if="passwordStrength==4"> Excelente.</div>
		</div>
	</div>
    
  </div>
</template>

<script>
import Password from 'vue-password-strength-meter'
export default {
	props: {
		context: {
			type: Object,
			required: true
		},
	},
  	components: {  
		Password
	},
	data () {
		return {
			passwordConfirm:'',
			showPassword:false,
			passwordStrength:0,
		}
	},
	methods:{
		passwordScore (score) {
			this.passwordStrength = score;
		},
	},
	computed: {
		formatted: {
			get: function() {
				return this.context.model;
			},
			set: function(newValue) {
				this.context.passConfirm = this.passwordConfirm;
				this.context.model = newValue;
			}
		}
	},
}
</script>

<style scoped>
.input-password{
	position:relative;
}
.password-feedback{
	font-size:12px;
}
.input-float-button{
    cursor: pointer;
    position: absolute;
    right: 6px;
    top: 0px;
    width: 30px;
    padding: 6px 4px;
    text-align: center;
    font-size: 16px;
}
</style>